<template>
  <div id="TopicList_main">
    <el-table
      :data="topicList"
      label-position="left"
      label-width="80px"
    >
      <el-table-column
        type="index"
        align="left"
        min-width="10"
      />
      <el-table-column
        label="議案標題"
        prop="title"
      />
      <el-table-column
        label="議案說明"
        prop="description"
      />
      <el-table-column
        label="統計規則"
        min-width="70"
      >
        <template slot-scope="scope">
          <span>依據</span>
          <span v-if="scope.row.useTablet">出席人數</span>
          <span v-if="scope.row.useTablet && scope.row.useArea">、</span>
          <span v-if="scope.row.useArea">區分所有權</span>
          <span>佔比</span>
        </template>
      </el-table-column>
      <el-table-column
        label="出席標準"
        min-width="28"
      >
        <template slot-scope="scope">
          <span class="num">{{ threshold(scope.row.attendanceThreshold) }}％</span>
        </template>
      </el-table-column>
      <el-table-column
        label="投票標準"
        min-width="28"
      >
        <template slot-scope="scope">
          <span class="num">{{ threshold(scope.row.consentThreshold) }}％</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    topicList: Array
  },
  data () {
    return {
      data: []
    }
  },
  methods: {
    threshold (attendanceThreshold) {
      return parseFloat((attendanceThreshold * 100).toPrecision(12))
    }
  }
}
</script>
<style lang="sass" scoped>
#TopicList_main
  ::v-deep .el-table
    +basicTable
    .el-table__body
      tr:hover,tr.hover-row
        > td
          background-color: $white
          &:first-child
            border-left: 0px
      .icon-trashcan
        color: $dangerColor
        font-size: 25px
        cursor: pointer
      .num
        font-weight: bold
        font-size: 18px
        letter-spacing: 2px
        color: $subFontColor
</style>
